export const renderPhraseString = (
  key: string,
  phraseStrings?: { [key: string]: string },
) => {
  return phraseStrings && phraseStrings[key]
    ? phraseStrings[key]
    : `${key} placeholder`;
};
